import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListarLocais from '../../components/locais';
import ItemBox from '../../components/shared/item_box'


function LocaisScreen() {
    return (
        <Fragment>
            <Head titulo="Órgãos Municipais da Prefeitura Municipal de Macuco" />
            <Header />
            <Container>
                 <ItemBox
                            titulo={"Responsáveis pelo Órgão:"}
                            texto={
                                <Fragment>
                                    <p>
                                       Cargo: Prefeita <br/>
                                       Ocupante: Michelle Bianchini Biscácio<br/>
                                    </p>
                                    <hr/>
                                    <p>
                                       Cargo: Vice-Prefeito <br/>
                                       Ocupante: João Batista da Silva Oliveira<br/>
                                    </p>
                                    <br />
                                </Fragment>
                            }
                        />
                <ListarLocais />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default LocaisScreen;